export let ButtonVariant = /*#__PURE__*/function (ButtonVariant) {
  ButtonVariant["Standard"] = "button";
  ButtonVariant["Small"] = "small";
  ButtonVariant["Light"] = "light";
  ButtonVariant["Primary"] = "primary";
  ButtonVariant["PrimarySmall"] = "primary-small";
  ButtonVariant["PrimaryLight"] = "primary-light";
  ButtonVariant["PrimaryIcon"] = "primary-icon";
  ButtonVariant["Icon"] = "icon";
  ButtonVariant["RoundIcon"] = "round-icon";
  ButtonVariant["LightSmall"] = "light-small";
  ButtonVariant["SmallIcon"] = "small-icon";
  return ButtonVariant;
}({}); // small lightweight icon
export let ButtonState = /*#__PURE__*/function (ButtonState) {
  ButtonState["Normal"] = "normal";
  ButtonState["Hover"] = "hover";
  ButtonState["Active"] = "active";
  return ButtonState;
}({});

/**
 * @deprecated
 * Use `theme` instead.
 */

/**
 * Data passed to consumers when using the `theme` API.
 */
//# sourceMappingURL=types.js.map